import React from 'react';
import PropTypes from 'prop-types';
import styles from './CodeInput.css';

class CodeInput extends React.Component {
  static propTypes = {
    length: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    length: 6,
    value: '',
  };

  boxRefs = [];

  setBoxRef = index => el => {
    this.boxRefs[index] = el;
  };

  emitChange = value => {
    this.props.onChange(value.slice(0, this.props.length));
  };

  handleChange = index => evt => {
    const digit = evt.target.value.replace(/\D/g, '').slice(-1);
    const chars = this.props.value.split('');
    chars[index] = digit;
    this.emitChange(chars.join(''));

    if (digit && index < this.props.length - 1) {
      const next = this.boxRefs[index + 1];
      if (next) {
        next.focus();
      }
    }
  };

  handleKeyDown = index => evt => {
    if (evt.key === 'Backspace' && !this.props.value[index] && index > 0) {
      const prev = this.boxRefs[index - 1];
      if (prev) {
        prev.focus();
      }
    }
  };

  handlePaste = evt => {
    evt.preventDefault();
    const pasted = (evt.clipboardData.getData('text') || '').replace(
      /\D/g,
      ''
    );
    if (!pasted.length) {
      return;
    }
    this.emitChange(pasted);
    const focusIndex = Math.min(pasted.length, this.props.length - 1);
    const box = this.boxRefs[focusIndex];
    if (box) {
      box.focus();
    }
  };

  render() {
    const { length, value } = this.props;
    return (
      <div className={styles.codeInput}>
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            ref={this.setBoxRef(index)}
            className={styles.codeBox}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value[index] || ''}
            onChange={this.handleChange(index)}
            onKeyDown={this.handleKeyDown(index)}
            onPaste={this.handlePaste}
          />
        ))}
      </div>
    );
  }
}

export default CodeInput;



// WEBPACK FOOTER //
// ./src/App/auth/components/CodeInput.js